import StockOpnameResult from '@/models/StockOpnameResult/StockOpnameResult';

export default class StockOpnameResultFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.stoResultNumber = '';
		this.id = '';
		this.stockOpnameId  = '';
		this.stockOpnameStockOpnamePlan = '';
		this.fileUploadId  = '';
		this.fileUploadOriginalFilename = '';
		this.areaId  = '';
		this.areaCode = '';
		this.stockOpnamePlanId  = '';
		this.stockOpnamePlanName = '';
		this.totalQtySystem = '';
		this.totalQtyActual = '';
		this.totalDifferenceQty = '';
		this.totalDifferencetPercentageQty = '';
		this.totalPriceQtySystem = '';
		this.totalPriceQtyActual = '';
		this.totalDifferencePrice = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
		this.isInProgressPlan = false;
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			stoResultNumber : '0',
			id : '0',
			stockOpnameId : '0',
			stockOpnameStockOpnamePlan : '0',
			fileUploadId : '0',
			fileUploadOriginalFilename : '0',
			areaId : '0',
			areaCode : '0',
			stockOpnamePlanId : '0',
			stockOpnamePlanName : '0',
			totalQtySystem : '0',
			totalQtyActual : '0',
			totalDifferenceQty : '0',
			totalDifferencetPercentageQty : '0',
			totalPriceQtySystem : '0',
			totalPriceQtyActual : '0',
			totalDifferencePrice : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}